// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Modal, message } from 'antd'
import './index.less'
import { MapBox } from '../map/Map'
import { getMapStyle } from '../map/helpers'
import { MapContext, Marker } from 'react-mapbox-gl'
import { ZoomControl, ControlGroup, RecenterControl } from 'components/map-controller'
import Cameras from '../map/Cameras'
import GPSTracker from '../map/gps-tracker'
import { Traces, StatusTraces } from '../map/Traces'
import { fetchDeviceById, IDeviceByIdResponse } from '../../api/devices'
import { RootState, Dispatch } from 'store'
import { connect } from 'react-redux'
import * as MapboxGl from 'mapbox-gl'
import moment from 'moment'
// @ts-ignore
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg'
import PhotoInvestigation from '../map-controller/PhotoInvestigation'

type ITraceModalProps = {
  onClose: () => void
  deviceId: string
  deviceDetails: IDeviceByIdResponse
  midLocation: any
  gridPoints: any
  mapInitZoom: number
} & MapStateProps &
  MapDispatchProps

interface ITraceModalState {
  cameraList: { lat: number; lon: number; deviceID: string }[]
}

class TraceModal extends React.Component<ITraceModalProps, ITraceModalState> {
  constructor (props: ITraceModalProps) {
    super(props)
    this.state = {
      cameraList: []
    }
  }

  map = null
  timeoutHandler = null

  componentDidMount () {
    const { setGPSTrackerVisible } = this.props
    setGPSTrackerVisible(true)
  }

  componentWillUnmount () {
    const { setGPSTrackerVisible,updateHoveredCamera } = this.props
    setGPSTrackerVisible(false)
    updateHoveredCamera(null)
  }

  async showDeviceTrace (deviceId) {
    const { setActiveDevice, fetchAndUpdateDeviceTrace, fetchAndUpdateDeviceStatuses, cities, midLocation, updateTraceTime } = this.props
    const device = await fetchDeviceById(deviceId)
    if (device) {
      let lat, lon
      const deviceCity = cities.find(c => c.id === device.cityID)
      if (midLocation && midLocation.midLat && midLocation.midLon) {
        
        lat = midLocation.midLat
        lon = midLocation.midLon
      } else {
        // If no lat/lng is found on the device. use the device's city center as lat/lng.
        lat = device.latitude !== 0 ? device.latitude : deviceCity.latitude
        lon = device.longitude !== 0 ? device.longitude : deviceCity.longitude
      }

      this.setState({
        cameraList: [
          {
            lat,
            lon,
            deviceID: device.deviceID
          }
        ]
      })
      this.map.panTo([lon, lat])
    }
    setActiveDevice(deviceId)
    updateTraceTime(this.getTraceDefTimePeriod())
    fetchAndUpdateDeviceTrace()
    fetchAndUpdateDeviceStatuses()
  }

  getTraceDefTimePeriod = () => {
    // temporarily add one day
    const startDate = moment().subtract(1, "days").set({ 'hour': 0, 'minute': 0, 'second': 0 })
    const endDate = moment().set({ 'hour': 23, 'minute': 59, 'second': 59 })
    return [startDate, endDate]
  }

  handleClose = () => {
    const { onClose } = this.props
    onClose()
  }

  handleCenterClick () {
    // recenter to camera.
    const { cameraList } = this.state
    const camera = cameraList[0]
    this.map.panTo([camera.lon, camera.lat])
  }

  handleMapStyleLoaded (map: MapboxGl.Map) {
    this.map = map
    const { deviceId } = this.props
    this.showDeviceTrace(deviceId).catch()
  }

  handleCameraHover (camera) {
    const { fetchCameraDetails, updateHoveredCamera } = this.props
    if (camera) {
      fetchCameraDetails({ deviceID: camera.deviceID, useCache: true })
      updateHoveredCamera(camera)
    }
  }

  handleMapClick (e) {
    const { updateHoveredCamera, hoveredCamera } = this.props
    if (hoveredCamera) {
      updateHoveredCamera(null)
    }
  }

  render () {
    const { cameraList = [] } = this.state
    const { traces, statusTraces, onCameraClick, deviceId, midLocation, gridPoints, mapInitZoom } = this.props

    console.log(traces)
    return (
      <Modal
        bodyStyle={{ padding: 0, margin: 0 }}
        closable={false}
        style={{ padding: 0, margin: 0, maxWidth: '100vw' }}
        centered={true}
        footer={null}
        title={null}
        wrapClassName='trace-model-wrap'
        visible={true}
        width='100vw'
      >
        <div onClick={this.handleClose} className='button-close'>
          <CloseIcon style={{ fontSize: '18px', stroke: '#50565E' }} />
        </div>
        <div style={{height:'100vh',width: '100vw' }} className={'mapbox-container'}>
          <MapBox
            movingMethod='jumpTo'
            zoom={[mapInitZoom]}
            onStyleLoad={this.handleMapStyleLoaded.bind(this)}
            style={getMapStyle('mono')}
            onClick={this.handleMapClick.bind(this)}
            containerStyle={{ height: '100vh', width: '100%' }}
          >
            {this.map ? <Traces traces={traces} map={this.map} /> : null}
            {this.map ? <StatusTraces statusTraces={statusTraces} map={this.map} midLocation={midLocation} gridPoints={gridPoints}/> : null}

            <Cameras
              cameraList={cameraList}
              onCameraHover={this.handleCameraHover.bind(this)}
              onCameraClick={onCameraClick}
            />
            <MapContext.Consumer>
              {map => {
                return (
                  <ControlGroup style={{ bottom:250, top: 'auto', right: 10 }}>
                    <PhotoInvestigation map={map}/>
                  </ControlGroup>
                )
              }}
            </MapContext.Consumer>
            <GPSTracker style={{ top: 10, position: 'absolute', right: 10 }} deviceId={deviceId} traces={traces}/>
            <MapContext.Consumer>
              {map => {
                return (
                  <ControlGroup style={{ bottom:60, top: 'auto', right: 10 }}>
                    <ZoomControl map={map} />
                  </ControlGroup>
                )
              }}
            </MapContext.Consumer>
          </MapBox>
        </div>
      </Modal>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {
    isGPSTrackerVisible: true,
    traces: state.gpsTrace.currentTrace,
    statusTraces: state.statusTrace.currentStatuses,
    cities: state.city.cityList,
    hoveredCamera: state.cameras.hoveredCamera
  }
}

function mapDispatchToProps (dispatch: Dispatch) {
  const { gpsTrace, cameras, download, statusTrace } = dispatch

  return {
    setActiveDevice: gpsTrace.setActiveDevice,
    fetchAndUpdateDeviceTrace: gpsTrace.fetchAndUpdateDeviceTrace,
    fetchAndUpdateDeviceStatuses: statusTrace.fetchAndUpdateDeviceStatuses,
    setGPSTrackerVisible: gpsTrace.setGPSTrackerVisible,
    fetchCameraDetails: cameras.fetchCameraDetails,
    updateHoveredCamera: cameras.updateHoveredCamera,
    onCameraClick: download.onCameraClick,
    updateTraceTime: gpsTrace.updateTraceTime
  }
}

type MapStateProps = ReturnType<typeof mapStateToProps>
type MapDispatchProps = ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(TraceModal)
